import uniq from 'utils/uniq';

/**
 * Transformer
 *
 * f(specifications, products, contentData) = CATEGORIES
 * @param {object} specifications
 * @param {Array} products
 * @param {Array} categoriesData
 * @returns {Array<object>}
 */
const categoryTransformer = (specifications, products, categoriesData) => {
  const categories = specifications.map(category => {
    const categoryData = categoriesData.find(item => item.id === category.id) || {};

    const prices = [];
    let currency;

    return {
      ...category,
      name: categoryData.name ?? category.name ?? 'N/A', // no content file for this category
      shortDescription: categoryData.shortDescription ?? category.shortDescription ?? 'N/A', // no content file for this category
      // Web-only overrides; undefined -> pages fall back to name / shortDescription
      seoTitle: categoryData.seoTitle ?? category.seoTitle,
      seoDescription: categoryData.seoDescription ?? category.seoDescription,
      heroTitle: categoryData.heroTitle ?? category.heroTitle,
      data: (category.data ?? []).map((item, index) => ({
        ...item,
        key: index,
        products: item.products
          .map(id => products.find(p => p.id === id))
          .filter(product => {
            if (product) {
              if (product.prices.length > 0) {
                prices.push(product.prices[0]);
                currency = product.currency;
              }
              return true;
            }
            return false;
          }),
      })),
      prices: uniq(prices).sort((a, b) => a - b),
      currency,
    };
  });

  return categories.map(category => ({
    ...category,
    data: category.data
      .map(item => ({
        ...item,
        subCategories: item.subCategories
          .map(id => categories.find(c => c.id === id))
          .filter(c => !!c),
      }))
      .filter(item => item.subCategories.length > 0 || item.products.length > 0),
  }));
};

export default categoryTransformer;
